import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const AdminProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" />;
  }

  const decoded = jwtDecode(token);
  const role = decoded.role;

  if (role !== 'admin') {
    return <Navigate to="/not-authorized" />;
  }

  return children;
};

export default AdminProtectedRoute;
